export const SPHERE_TOOLBAR = [
  {
    name: "Leadership",
    title: "Leadership",
    icon: (cls) => (
      <svg viewBox="0 0 24 24" className={cls} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeLinejoin="round" />
      </svg>
    ),
    activeRing: "ring-purple-500/70",
    activeBg: "bg-purple-950/70 text-purple-100",
    idleHover: "hover:bg-slate-800",
  },
  {
    name: "Tactics",
    title: "Tactics",
    icon: (cls) => (
      <svg viewBox="0 0 24 24" className={cls} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M4 4l16 16M20 4L4 20" strokeLinecap="round" />
      </svg>
    ),
    activeRing: "ring-red-500/70",
    activeBg: "bg-red-950/70 text-red-100",
    idleHover: "hover:bg-slate-800",
  },
  {
    name: "Spirit",
    title: "Spirit",
    icon: (cls) => (
      <svg viewBox="0 0 24 24" className={cls} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path
          d="M12 2.7c2.8 3.8 4.5 7.2 4.5 10.3a4.5 4.5 0 11-9 0c0-3.1 1.7-6.5 4.5-10.3z"
          strokeLinejoin="round"
        />
      </svg>
    ),
    activeRing: "ring-sky-500/70",
    activeBg: "bg-sky-950/70 text-sky-100",
    idleHover: "hover:bg-slate-800",
  },
  {
    name: "Lore",
    title: "Lore",
    icon: (cls) => (
      <svg viewBox="0 0 24 24" className={cls} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M4 19.5A2.5 2.5 0 016.5 17H20" strokeLinecap="round" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" strokeLinejoin="round" />
      </svg>
    ),
    activeRing: "ring-emerald-500/70",
    activeBg: "bg-emerald-950/70 text-emerald-100",
    idleHover: "hover:bg-slate-800",
  },
  {
    name: "Neutral",
    title: "Neutral",
    icon: (cls) => (
      <svg viewBox="0 0 24 24" className={cls} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="3" fill="currentColor" stroke="none" />
      </svg>
    ),
    activeRing: "ring-slate-400/80",
    activeBg: "bg-slate-700/80 text-slate-100",
    idleHover: "hover:bg-slate-800",
  },
];
